'use client';

import { useAppType } from '@capsicum/common';
import { useCallback } from 'react';

import { getGeetestChallenge } from '../data-access';
import { type GeetestChallengeMetadata } from '../models';

export const useGeetest = () => {
	const appType = useAppType();

	return useCallback(
		({ metadata }: { metadata?: GeetestChallengeMetadata } = {}) => getGeetestChallenge(appType, metadata),
		[appType]
	);
};
